import { useState, useEffect } from "react";
import { Popover, PopoverBody } from "reactstrap";

const SelectMistakePopUp = ({
  open,
  targetId,
  onClose,
  onSelect,
  miscueList,
  currentMistakeId,
  editionMode = true,
}) => {
  const [isSelected, setIsSelected] = useState(null);

  useEffect(() => {
    if (open) {
      setIsSelected(currentMistakeId || null);
    }
  }, [open, currentMistakeId]);

  if (!open || !targetId || !editionMode) return null;

  const handleSelect = (mistake) => {
    if (isSelected === mistake.id) {
      setIsSelected(null);
      onSelect(null);
    } else {
      setIsSelected(mistake.id);
      onSelect(mistake);
    }
    onClose();
  };

  return (
    <Popover
      isOpen={open}
      target={targetId}
      toggle={onClose}
      placement="bottom"
      trigger="legacy"
      hideArrow={true}
      innerClassName="p-0 border-0 bg-transparent"
      className="border-0"
      style={{
        boxShadow: "none",
        backgroundColor: "transparent",
        border: "none",
        zIndex: 10000,
      }}
    >
      <PopoverBody className="p-0 border-0">
        <div
          style={{
            backgroundColor: "#ffffff",
            border: "1px solid #f1f5f9",
            borderRadius: "24px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
            padding: "20px",
            width: "360px",
            maxWidth: "360px",
            direction: "rtl",
            fontFamily: "inherit",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "16px",
              fontSize: "15px",
              fontWeight: "600",
              color: "#718096",
            }}
          >
            اختر نوع الخطأ
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "12px",
            }}
          >
            {miscueList?.map((mistake) => {
              const isSelectedMistake = isSelected === mistake.id;
              const baseColor = mistake.color || "#718096";
              const bgColor = "#f3f6faff";

              return (
                <button
                  key={mistake.id}
                  type="button"
                  onClick={() => handleSelect(mistake)}
                  className="mistake-popup-option-btn"
                  style={{
                    backgroundColor: bgColor,
                    border: `${isSelectedMistake ? "2px" : "1px"} solid ${baseColor}`,
                    transform: isSelectedMistake ? "scale(0.98)" : "none",
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor: baseColor,
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#2d3748",
                    }}
                  >
                    {mistake.title}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </PopoverBody>
    </Popover>
  );
};

export default SelectMistakePopUp;
